import { CommonCaseTypeResponse } from '@/api/services/common/case-type/common-case-type.dto'
import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import { CommonPriorityResponse } from '@/api/services/common/priority/common-priority.dto'
import { StatisticalAnalysisContentScrollTable, StatisticalAnalysisExternalListTypes, StatisticalAnalysisViewDetailTableGroupingColumns } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { Nullable } from '@/shared/types/app.types'

export enum StatisticalAnalysisActivityStatisticsDossierGroupColumnsEnum {
    CASE_TYPE = 'CASE_TYPE',
    PHYSICIAN_DEPARTMENT = 'PHYSICIAN_DEPARTMENT',
    PHYSICIAN_CENTER = 'PHYSICIAN_CENTER',
    PHYSICIAN_HEALTH_MANAGEMENT_AREA = 'PHYSICIAN_HEALTH_MANAGEMENT_AREA',
    PRIORITY = 'PRIORITY',
    PATHOLOGIST = 'PATHOLOGIST',
    REGIME = 'REGIME',
    LABORATORY = 'LABORATORY',
    RESIDENT = 'RESIDENT',
    PHYSICIAN_PETITIONER = 'PHYSICIAN_PETITIONER',
    CASE_OF_REFERENCE = 'CASE_OF_REFERENCE'
}

export enum StatisticalAnalysisActivityStatisticsDossierGroupRequestEnum {
    ORIGIN = 'ORIGIN',
    TYPE = 'TYPE',
    SEVERITY = 'SEVERITY',
    ENTITY = 'ENTITY',
    OPENEDBY = 'OPENEDBY',
    CLOSEDBY = 'CLOSEDBY',
    PATHOLOGIST = 'PATHOLOGIST',
    PHYSICIAN_DEPARTMENT = 'PHYSICIAN_DEPARTMENT',
    PHYSICIAN_CENTER = 'PHYSICIAN_CENTER',
    PHYSICIAN_PETITIONER = 'PHYSICIAN_PETITIONER',
    PHASE = 'PHASE'
}
export interface StatisticalAnalysisActivityStatisticsDossierCaseStates {
    total: number
    totalURV: number
    totalUCL: number
}

export interface StatisticalAnalysisActivityStatisticsDossierBaseRequest {
    startDate: string,
    endDate: string,
    laboratoryIds: number[],
    stateIds: string[],
    laboratoryUserId: number
}

export interface StatisticalAnalysisActivityStatisticsDossierDetailRequest {
    groupByFields: string[]
}

export interface StatisticalAnalysisActivityStatisticsDossierGroupRequest {
    groupBy1: StatisticalAnalysisActivityStatisticsDossierGroupRequestEnum
    groupBy2: StatisticalAnalysisActivityStatisticsDossierGroupRequestEnum
}

export interface StatisticalAnalysisActivityStatisticsDossierDetailViewChartResponseInternalGroups {
    name: string
    total: number
    totalUCL: number
    totalURV: number
}

export interface StatisticalAnalysisActivityStatisticsDossierDetailViewChart {
    groupBy1: string
    groupBy2: StatisticalAnalysisActivityStatisticsDossierDetailViewChartResponseInternalGroups[]
}
export interface StatisticalAnalysisActivityStatisticsDossierDetailViewTableContentCase {
    caseOfReference: StatisticalAnalysisViewDetailTableGroupingColumns
    caseType: StatisticalAnalysisViewDetailTableGroupingColumns
    laboratory: StatisticalAnalysisViewDetailTableGroupingColumns
    macroUCL: number
    pathologist: StatisticalAnalysisViewDetailTableGroupingColumns
    physicianCenter: StatisticalAnalysisViewDetailTableGroupingColumns
    physicianDepartment: StatisticalAnalysisViewDetailTableGroupingColumns
    physicianHealthManagementArea: StatisticalAnalysisViewDetailTableGroupingColumns
    priority: StatisticalAnalysisViewDetailTableGroupingColumns
    regime: StatisticalAnalysisViewDetailTableGroupingColumns
    reportUCL: number
    resident: StatisticalAnalysisViewDetailTableGroupingColumns
    physicianPetitioner: StatisticalAnalysisViewDetailTableGroupingColumns
    totalCases: number
    totalUCL: number
    totalURV: number
}

export interface StatisticalAnalysisActivityStatisticsDossierDetailViewTable {
    content: StatisticalAnalysisActivityStatisticsDossierDetailViewTableContentCase[]
    scrollPage: StatisticalAnalysisContentScrollTable
}

export interface StatisticalAnalysisActivityStatisticsDossierDetailExternalViewTable {
    content: StatisticalAnalysisExternalListTypes[]
    scrollPage: StatisticalAnalysisContentScrollTable
}
